import { render, staticRenderFns } from "./muokkaa-suoritemerkintaa.vue?vue&type=template&id=51f477db&scoped=true&"
import script from "./muokkaa-suoritemerkintaa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-suoritemerkintaa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-suoritemerkintaa.vue?vue&type=style&index=0&id=51f477db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f477db",
  null
  
)

export default component.exports